import { put, delay, call, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';


function* myPersonalitySave(action) {
  yield put(loadingSet(true));

  const {res, err} = yield call(function (payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'save');
    params.append('EI', payload.pointEI);
    params.append('SN', payload.pointSN);
    params.append('TF', payload.pointTF);
    params.append('JP', payload.pointJP);
    return axios.post(config.apiUri + "member/myPersonalityEditApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield delay(500);
      yield put({ type:'SNACK_SET', payload: {visible: true, severity: 'success', duration: 5000, comment:'性格診断を保存しました'}});
      yield put({
        type: "MY_PROFILE_GET",
        payload: {
          item: ['personality'],
        },
      });

      yield delay(500);
      action.callback(res);
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* myPersonalityDel(action) {
  yield put(loadingSet(true));

  const {res, err} = yield call(function (payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'del');
    return axios.post(config.apiUri + "member/myPersonalityEditApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "MY_PERSONALITY_RESET",
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

const saga = [
  takeLatest('MY_PERSONALITY_SAVE', myPersonalitySave),
  takeLatest('MY_PERSONALITY_DEL', myPersonalityDel),
];

export default saga;
